<template>
  <v-container fluid px-0 pt-0>
    <v-layout row wrap>
      <v-flex xs10 sm6 offset-sm3 mt-3 mx-auto>
        <register-form />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  components: {
    RegisterForm: () =>
      import(
        /* webpackChunkName: "RegisterForm" */ '@/components/Login/RegisterForm'
      )
  },
  head: {
    title() {
      return {
        inner: 'Registreeru - Piletivahetus.ee'
      }
    },
    meta: [
      {
        name: 'description',
        content:
          'Kas Sa jäid pileti ostamisega hiljaks? Või just sooviksid oma teatri, kontserti pileti edasi müüa? Piletivahetus aitab!',
        id: 'desc'
      }
    ]
  }
}
</script>
